import { Tab, Card } from '@citi-icg-172888/icgds-react';
import CreateLeadScoreList from "../external/components/CreateLeadScoreList";
import CreateLeadScoreView from "../external/components/CreateLeadScoreView";
import { useData } from '../services/context/DataContext';
import { useEffect } from 'react';
import { GET_LEAD_ADMIN_SCORE, GET_LEAD_LIST } from '../services/api/apiUrls';

const LeadScore: React.FC = () => {
    const { setUrlFetch } = useData();
    useEffect(() => { setUrlFetch(GET_LEAD_ADMIN_SCORE) });
    const handleClick = (e: any) => {
        switch (e) {
            case "1":
                setUrlFetch(GET_LEAD_ADMIN_SCORE)
                break;
            case "2":
                setUrlFetch(GET_LEAD_LIST);
                break;
            default:
                console.log("Tab Clicked", e);
        }
    }
    return (
        <Card className="lmn-d-flex lmn-flex-column lmn-h-100 app-container" id="lead_score">
            <Tab data-cv-tracking-id="tab-tracking-id" defaultActiveKey="1" onTabClick={(e: any)=> handleClick(e)}>
                <Tab.TabPane data-cv-tracking-id="tab-pane-tracking-id" tab="Lead Score" key="1" ><CreateLeadScoreView/> </Tab.TabPane>
                <Tab.TabPane tab="Lead List" key="2"><CreateLeadScoreList/></Tab.TabPane>
            </Tab>
        </Card>
    );
  }
  export default LeadScore;